import apiHelper from '../helpers/apiHelper'

export default {
  get()
  {
    return apiHelper.request('filters')
  },
  set(data)
  {
    return apiHelper.request('user-filters', data, 'POST')
  },
  delete(id)
  {
    return apiHelper.request('user-filters/' + id, '', 'DELETE')
  }
}
